module.exports = __webpack_public_path__ + "media/locales/_us-bdcaa975.png";